import { useLocation } from "react-router-dom";

export const getCommercialHeaderText = (params) => {
  const category = params.get("category") || "commercial";

  const categoryTextMap = {
    retail: "Retail Properties",
    multi_family: "Multi-Family Apartments",
    office_building: "Office Buildings",
    industrial: "Industrial Properties",
  };

  return categoryTextMap[category] ? categoryTextMap[category] : "Commercial Properties";
};

const CommercialHeader = () => {
  const location = useLocation();
  const params = new URLSearchParams(location.search);
  const headingText = getCommercialHeaderText(params);

  return <h6 className="mb-0">{headingText}</h6>;
};

export default CommercialHeader;
